import {Component, inject} from '@angular/core';
import {SearchInputViewService} from '../../services/search.service';
import {ReactiveFormsModule} from '@angular/forms';
import {FilterComponent} from '../elements/components/filter/filter.component';

@Component({
  selector: 'app-search',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    FilterComponent
  ],
  templateUrl: './search.component.html',
  styleUrl: './search.component.scss'
})
export class SearchComponent {
  searchService = inject(SearchInputViewService);
}
